"use strict";

function cov_1tc0btabwu() {
  var path = "/mnt/c/Users/lostos/Documents/GitKraken/redux-sounds/src/index.js";
  var hash = "fcfa9163a41276784b300899d118750d2ec5c194";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/mnt/c/Users/lostos/Documents/GitKraken/redux-sounds/src/index.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 26
        },
        end: {
          line: 1,
          column: 57
        }
      },
      "1": {
        start: {
          line: 2,
          column: 31
        },
        end: {
          line: 2,
          column: 49
        }
      },
      "2": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 59
        }
      },
      "3": {
        start: {
          line: 8,
          column: 18
        },
        end: {
          line: 8,
          column: 59
        }
      },
      "4": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 42,
          column: 4
        }
      },
      "5": {
        start: {
          line: 10,
          column: 15
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "6": {
        start: {
          line: 10,
          column: 25
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "7": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 5
        }
      },
      "8": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 26
        }
      },
      "9": {
        start: {
          line: 15,
          column: 20
        },
        end: {
          line: 15,
          column: 50
        }
      },
      "10": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 40,
          column: 7
        }
      },
      "11": {
        start: {
          line: 17,
          column: 21
        },
        end: {
          line: 17,
          column: 46
        }
      },
      "12": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 21,
          column: 7
        }
      },
      "13": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 38
        }
      },
      "14": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 15
        }
      },
      "15": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 64
        }
      },
      "16": {
        start: {
          line: 23,
          column: 57
        },
        end: {
          line: 23,
          column: 64
        }
      },
      "17": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 27,
          column: 7
        }
      },
      "18": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 43
        }
      },
      "19": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 15
        }
      },
      "20": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 39,
          column: 7
        }
      },
      "21": {
        start: {
          line: 29,
          column: 40
        },
        end: {
          line: 29,
          column: 60
        }
      },
      "22": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 35,
          column: 10
        }
      },
      "23": {
        start: {
          line: 37,
          column: 40
        },
        end: {
          line: 37,
          column: 57
        }
      },
      "24": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 63
        }
      },
      "25": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 24
        }
      },
      "26": {
        start: {
          line: 45,
          column: 0
        },
        end: {
          line: 45,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "soundsMiddleware",
        decl: {
          start: {
            line: 4,
            column: 9
          },
          end: {
            line: 4,
            column: 25
          }
        },
        loc: {
          start: {
            line: 4,
            column: 38
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 9
          },
          end: {
            line: 10,
            column: 10
          }
        },
        loc: {
          start: {
            line: 10,
            column: 15
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 15
          },
          end: {
            line: 10,
            column: 16
          }
        },
        loc: {
          start: {
            line: 10,
            column: 25
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 25
          },
          end: {
            line: 10,
            column: 26
          }
        },
        loc: {
          start: {
            line: 10,
            column: 37
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 16,
            column: 20
          },
          end: {
            line: 16,
            column: 21
          }
        },
        loc: {
          start: {
            line: 16,
            column: 32
          },
          end: {
            line: 40,
            column: 5
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 59
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 20
          }
        }, {
          start: {
            line: 12,
            column: 24
          },
          end: {
            line: 12,
            column: 62
          }
        }],
        line: 12
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 21,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 21,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 23,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 23,
            column: 64
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 24
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        }, {
          start: {
            line: 36,
            column: 13
          },
          end: {
            line: 39,
            column: 7
          }
        }],
        line: 28
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fcfa9163a41276784b300899d118750d2ec5c194"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tc0btabwu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1tc0btabwu();

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var howlerIntegration = (cov_1tc0btabwu().s[0]++, require('./howler_integration'));

var _ref = (cov_1tc0btabwu().s[1]++, require('./utils')),
    isObjectWithValues = _ref.isObjectWithValues;

function soundsMiddleware(soundsData) {
  cov_1tc0btabwu().f[0]++;
  cov_1tc0btabwu().s[2]++;

  // Set up our sounds object, and pre-load all audio files.
  // Our sounds object basically just takes the options provided to the
  // middleware, and constructs a new Howl object for each one with them.
  if (soundsData) {
    cov_1tc0btabwu().b[0][0]++;
    cov_1tc0btabwu().s[3]++;
    howlerIntegration.initialize(soundsData);
  } else {
    cov_1tc0btabwu().b[0][1]++;
  }

  cov_1tc0btabwu().s[4]++;
  return function () {
    cov_1tc0btabwu().f[1]++;
    cov_1tc0btabwu().s[5]++;
    return function (next) {
      cov_1tc0btabwu().f[2]++;
      cov_1tc0btabwu().s[6]++;
      return function (action) {
        cov_1tc0btabwu().f[3]++;
        cov_1tc0btabwu().s[7]++;

        // Ignore actions that haven't specified a sound.
        if ((cov_1tc0btabwu().b[2][0]++, !action.meta) || (cov_1tc0btabwu().b[2][1]++, !isObjectWithValues(action.meta.sound))) {
          cov_1tc0btabwu().b[1][0]++;
          cov_1tc0btabwu().s[8]++;
          return next(action);
        } else {
          cov_1tc0btabwu().b[1][1]++;
        }

        var methods = (cov_1tc0btabwu().s[9]++, Object.keys(action.meta.sound));
        cov_1tc0btabwu().s[10]++;
        methods.forEach(function (method) {
          cov_1tc0btabwu().f[4]++;
          var target = (cov_1tc0btabwu().s[11]++, action.meta.sound[method]);
          cov_1tc0btabwu().s[12]++;

          if (method === 'add') {
            cov_1tc0btabwu().b[3][0]++;
            cov_1tc0btabwu().s[13]++;
            howlerIntegration.add(target);
            cov_1tc0btabwu().s[14]++;
            return;
          } else {
            cov_1tc0btabwu().b[3][1]++;
          } // skip action, no Howls initialized


          cov_1tc0btabwu().s[15]++;

          if (!isObjectWithValues(howlerIntegration.sounds)) {
            cov_1tc0btabwu().b[4][0]++;
            cov_1tc0btabwu().s[16]++;
            return;
          } else {
            cov_1tc0btabwu().b[4][1]++;
          }

          cov_1tc0btabwu().s[17]++;

          if (method === 'playlist') {
            cov_1tc0btabwu().b[5][0]++;
            cov_1tc0btabwu().s[18]++;
            howlerIntegration.playlist(target);
            cov_1tc0btabwu().s[19]++;
            return;
          } else {
            cov_1tc0btabwu().b[5][1]++;
          }

          cov_1tc0btabwu().s[20]++;

          if (Array.isArray(target)) {
            cov_1tc0btabwu().b[6][0]++;

            var _ref2 = (cov_1tc0btabwu().s[21]++, target[0].split('.')),
                _ref3 = _slicedToArray(_ref2, 2),
                soundName = _ref3[0],
                spriteName = _ref3[1];

            cov_1tc0btabwu().s[22]++;
            howlerIntegration.proxy.apply(howlerIntegration, [soundName, spriteName, method].concat(_toConsumableArray(target.slice(1))));
          } else {
            cov_1tc0btabwu().b[6][1]++;

            var _ref4 = (cov_1tc0btabwu().s[23]++, target.split('.')),
                _ref5 = _slicedToArray(_ref4, 2),
                _soundName = _ref5[0],
                _spriteName = _ref5[1];

            cov_1tc0btabwu().s[24]++;
            howlerIntegration.proxy(_soundName, _spriteName, method);
          }
        });
        cov_1tc0btabwu().s[25]++;
        return next(action);
      };
    };
  };
}

cov_1tc0btabwu().s[26]++;
module.exports = soundsMiddleware;